import api from "./api"

export const getDebts = async () => {
  const response = await api.get("/debts")
  return response.data
}

export const getDebtById = async (debtId) => {
  const response = await api.get(`/debts/${debtId}`)
  return response.data
}

export const getDebtFormData = async () => {
  const response = await api.get("/debts/form-data")
  return response.data
}

export const createDebt = async (payload) => {
  const response = await api.post("/debts", payload)
  return response.data
}

export const updateDebt = async (debtId, payload) => {
  const response = await api.put(`/debts/${debtId}`, payload)
  return response.data
}

export const deleteDebt = async (debtId) => {
  const response = await api.delete(`/debts/${debtId}`)
  return response.data
}